'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import { useBreakpoint } from '@eliadmin/core/src/hooks/use-breakpoint';
import { animate, motion, useMotionValue } from 'framer-motion';
import { useEffect } from 'react';

import useMeasure from 'react-use-measure';

export function LogoRolling() {
  const images = [
    {
      image: { url: '/images/name.svg' },
    },
    {
      image: { url: '/images/name.svg' },
    },
    {
      image: { url: '/images/name.svg' },
    },
    {
      image: { url: '/images/name.svg' },
    },
    {
      image: { url: '/images/name.svg' },
    },
    {
      image: { url: '/images/name.svg' },
    },
  ];

  const [ref, { width }] = useMeasure();

  const xTranslation = useMotionValue(0);

  const isDesktop = useBreakpoint('sm');

  useEffect(() => {
    const finalPosition = -width / 2 - 64;

    const controls = animate(xTranslation, [0, finalPosition], {
      ease: 'linear',
      duration: isDesktop ? 20 : 10,
      repeat: Infinity,
      repeatType: 'loop',
      repeatDelay: 0,
    });

    return controls.stop;
  }, [xTranslation, width]);

  return (
    <main className="my-8 w-full overflow-hidden sm:my-12 lg:my-16">
      <motion.div className="left-0 flex w-full gap-16" ref={ref} style={{ x: xTranslation }}>
        {[...images, ...images].map((image, index) => (
          <Image
            key={index}
            src={image.image.url}
            alt={resolveImageAlt(image?.image, 'logo')}
            width={0}
            height={0}
            className="h-[100px] w-auto object-cover object-center sm:h-[120px] md:h-[200px] lg:h-[340px] xl:h-[400px]"
          />
        ))}
      </motion.div>
    </main>
  );
}
